/* Generated by ./script/iconify.js */
/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import IconBase from './IconBase'
import classnames from 'classnames'

const IconError500To503 = ({ className, ...rest }) => {
  const classes = classnames(
    'icon',
    'icon--error500to503',
    className,
  )

  return (
    <IconBase className={classes} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 173.1 136.7"{...rest}><path className="path1" fill="#00A1DE" d="M164.3 136.7H8.7c-4.8 0-8.7-3.9-8.7-8.7 0-4.8 3.9-8.7 8.7-8.7h155.6c4.8 0 8.7 3.9 8.7 8.7.1 4.8-3.9 8.7-8.7 8.7z"/><path className="path2" fill="#004BB7" d="M114.3 136.7H8.7c-4.8 0-8.7-3.9-8.7-8.7 0-4.8 3.9-8.7 8.7-8.7h105.5c4.8 0 8.7 3.9 8.7 8.7.1 4.8-3.8 8.7-8.6 8.7z"/><path className="path3" fill="#0068C6" d="M69.5 54.3h34.1v75.6H69.5z"/><path className="path4" fill="#0068C6" d="M116.4 130.9H56.6c-1.6 0-2.9-1.3-2.9-2.9 0-1.6 1.3-2.9 2.9-2.9h59.8c1.6 0 2.9 1.3 2.9 2.9.1 1.6-1.3 2.9-2.9 2.9z"/><path className="path5" fill="#00A1DE" d="M168.3 108.7H4.8c-2.6 0-4.8-2.1-4.8-4.8V4.8C0 2.1 2.1 0 4.8 0h163.5c2.6 0 4.8 2.1 4.8 4.8v99.1c0 2.6-2.2 4.8-4.8 4.8z"/><path className="path6" fill="#0068C6" d="M0 4.8v99.1c0 2.6 2.1 4.8 4.8 4.8h163.5c2.6 0 4.8-2.1 4.8-4.8"/><path className="path7" fill="#004BB7" d="M69.5 125v-16.3h34.1z"/><path className="path8" fill="#6ACEE5" d="M160.9 99.9H10.6c-1.1 0-2.1-.9-2.1-2.1V11.4c0-1.1.9-2.1 2.1-2.1h150.3c1.1 0 2.1.9 2.1 2.1v86.4c0 1.2-.9 2.1-2.1 2.1z"/><path className="path9" fill="#004BB7" d="M103.2 42.7c-.1-.3-.4-.6-.7-.6-.3-.1-.7 0-.9.3l-4 4-3.6-3.6 3.9-3.9c.2-.2.3-.6.3-.9-.1-.3-.3-.6-.7-.7-3.2-1-6.6-.2-8.9 2.2-1.7 1.5-2.6 3.7-2.6 6.1 0 .4 0 .8.1 1.2L69.5 63.4c-2.1 2.1-2.1 5.5 0 7.6 1 1 2.4 1.6 3.8 1.6s2.7-.5 3.8-1.6l16.6-16.6c.4.1.8.1 1.2.1 2.4 0 4.6-.9 6.2-2.6 2.4-2.5 3.2-6 2.1-9.2zM74.5 68.4c-.4.4-1 .5-1.3.5-.3 0-.8-.1-1.3-.5-.3-.3-.5-.8-.5-1.3s.2-.9.5-1.3c.5-.4 1-.5 1.3-.5.3 0 .8.1 1.3.5.7.8.7 1.9 0 2.6z"/></IconBase>
  )
}

IconError500To503.propTypes = {
  className: PropTypes.string,
}

export default IconError500To503
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/icons/IconError500To503.js